import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33307cbe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/box.css?vue&type=style&index=0&id=33307cbe&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=33307cbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33307cbe",
  null
  
)

export default component.exports